import gql from 'graphql-tag';

const query = gql`
  query DietSettings($date: Date!) {
    me {
      id
      sex
      systemOfMeasures
      systemOfMeasuresNutrition
      birthDate
      height {
        value
        unit
      }
      lastMeasurement: measurement {
        weight(request: { limit: 1 }) {
          value
          unit
        }
      }
      goalWeight {
        value
        unit
      }
      diet {
        mode
        id
        name
        activityLevel
        spontaneousActivityLevel
        macronutrientRatio {
          protein
          fat
          carbohydrate
        }
        preferredMacronutrientRatio {
          protein
          fat
          carbohydrate
        }
        dietType
      }
      isVegetarian
      isPescoVegetarian
    }
    dailyTracker {
      data(date: $date) {
        date
        baseCalories
      }
    }
  }
`;

export default query;
